import React, { useState } from 'react'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker'
import { PickersDay, pickersDayClasses } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import { ReactComponent as CalendarIcon } from 'assets/icons/svg/Calendar.svg'

import { format } from 'date-fns'
import AdxButton from './AdxButton'

const AdxPickerDay = (date, selectedDates, pickersDayProps) => {
  //ALL THE PROPS; date, selectedDates, pickersDayProps;
  //must be included in params above eventhough it is not called below.
  //Removing it will crash the calendar.
  return (
    <PickersDay
      {...pickersDayProps}
      sx={{
        [`&&.${pickersDayClasses.selected}`]: {
          backgroundColor: 'alternate.main',
          color: 'white.main',
          fontWeight: 'bold',
        },
        [`&&.${pickersDayClasses.root}`]: {
          fontSize: '14px',
          borderRadius: 2,
        },
        [`&&.${pickersDayClasses.today}`]: {
          borderWidth: '2px',
          borderColor: 'alternate.main',
        },
        [`&&.${pickersDayClasses.disabled}`]: {
          color: 'light-gray-text-2.main',
        },
      }}
    />
  )
}

const AdxDatePickerV2 = ({
  selectedDate,
  setSelectedDate,
  disabled = false,
  sx,
  iconStart = 'right',
  ...rest
}) => {
  const [calendarOpen, setCalendarOpen] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const formattedSelectedDate = selectedDate
    ? format(new Date(selectedDate), 'EEEE, MMM dd, yyyy')
    : ''

  const handleOpen = (event) => {
    setCalendarOpen(true)
    setAnchorEl(event.currentTarget)
  }

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        open={calendarOpen}
        onClose={() => setCalendarOpen(false)}
        value={selectedDate}
        inputFormat="dd/MM/yyyy"
        PopperProps={{
          placement: 'bottom-start',
          anchorEl: anchorEl,
        }}
        onChange={handleDateChange}
        {...rest}
        renderInput={(params) => (
          <AdxButton
            variant="outlined"
            onClick={handleOpen}
            sx={{ borderColor: 'gray-line.main', width: { xs: '100%', md: 'auto' }, ...sx }}
            ref={params.inputRef}
            disabled={disabled}
          >
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'start',
                gap: 2,
                flexDirection: iconStart === 'right' ? 'row' : 'row-reverse',
              }}
            >
              <Typography
                sx={{
                  color: disabled ? 'light-gray-text-2.main' : 'light-gray-text.main',
                  fontWeight: 400,
                }}
              >
                {formattedSelectedDate}
              </Typography>
              <CalendarIcon width={25} color="#2666BE" />
            </Box>
          </AdxButton>
        )}
        renderDay={AdxPickerDay}
      />
    </LocalizationProvider>
  )
}

export default AdxDatePickerV2
